import {translate} from '../plugins/i18n';
import {HitUtils} from '@hit/components/src/utils/hit/HitUtils';

/**
 * Breadcrumb helpers for admin UI routes (trackerList, trackerDetail, …).
 */
export class HitRouteUtils {
  static getEntityListRoute(entityType) {
    const type = entityType === 'projectPart' ? 'project' : entityType;
    return {
      label: translate(`hit-admin.common.${HitUtils.camelToKebab(type)}`, 2),
      route: `${type}List`,
    };
  }

  static getEntityDetailRoute(entityType, entityFullDesignation, entityId) {
    return {
      label: entityFullDesignation,
      route: `${entityType}Detail`,
      routeParams: {
        id: entityId || 0,
      },
    };
  }

  static getModelDetailRoute(entityModel) {
    return {
      label: entityModel?.entityDesignation,
      route: entityModel?.detailPageRoute,
      routeParams: {
        id: entityModel?.id || 0,
      },
    };
  }

  static getCurrentRoute(designation) {
    return {
      label: designation,
      route: '',
    };
  }
}
